import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { Nav, Footer } from "./Nav";
import { api } from "../api";
import { initPixel, pixelTrack } from "../lib/pixel";

export function PaypalReturn() {
  const navigate = useNavigate();
  const [state, setState] = useState("checking");
  const [info, setInfo] = useState(null);

  useEffect(() => {
    const p = new URLSearchParams(window.location.search);
    const payload = {
      plan: p.get("plan"),
      item_id: p.get("item_id"),
      token: p.get("token"),
      subscription_id: p.get("subscription_id"),
    };
    if (!payload.token && !payload.subscription_id) { setState("error"); return; }
    (async () => {
      try {
        const { data } = await api.post("/paypal/capture", payload);
        if (data.payment_status === "paid") {
          if (data.item_id === "nlp_practitioner") {
            initPixel();
            pixelTrack("Purchase", { value: Number(data.amount) || 0, currency: (data.currency || "GBP") });
          }
          setInfo(data); setState("paid");
        } else setState("pending");
      } catch { setState("error"); }
    })();
  }, []);

  return (
    <>
      <Nav />
      <section className="hero" style={{ minHeight: "60vh", background: "linear-gradient(180deg,#1c1a17,#141414)" }}>
        <div className="wrap hero-inner" style={{ textAlign: "center" }} data-testid="paypal-return">
          {state === "checking" && (<>
            <Loader2 size={44} style={{ color: "#C7921E" }} />
            <h1 style={{ marginTop: "1rem" }}>Confirming your PayPal payment…</h1>
            <p className="lead">One moment while we finalise your enrolment.</p>
          </>)}
          {state === "paid" && (<>
            <CheckCircle2 size={48} style={{ color: "#3fce7a" }} />
            <h1 style={{ marginTop: "1rem" }}>You're in. Welcome aboard.</h1>
            <p className="lead" data-testid="paypal-success-msg">
              Your enrolment on <strong>{info?.title}</strong> is confirmed
              {info?.plan === "installment" ? " on the 6-month PayPal plan" : " — and your Passing Guarantee is active"}.
            </p>
            <div className="actions" style={{ justifyContent: "center" }}>
              <button className="btn btn-primary" onClick={() => navigate(`/study/${info?.item_id}`)}>Enter your study room</button>
              <Link className="btn btn-gold-outline" to="/hub">Go to My Hub</Link>
            </div>
          </>)}
          {state === "pending" && (<>
            <Loader2 size={44} style={{ color: "#C7921E" }} />
            <h1 style={{ marginTop: "1rem" }}>Almost there…</h1>
            <p className="lead">Your payment is processing — your access will unlock shortly. Check My Hub in a minute.</p>
            <Link className="btn btn-primary" to="/hub">Go to My Hub</Link>
          </>)}
          {state === "error" && (<>
            <XCircle size={44} style={{ color: "#b0392b" }} />
            <h1 style={{ marginTop: "1rem" }}>We couldn't confirm that.</h1>
            <p className="lead">If you were charged, don't worry — contact us and we'll sort it right away.</p>
            <Link className="btn btn-primary" to="/hub">Go to My Hub</Link>
          </>)}
        </div>
      </section>
      <Footer />
    </>
  );
}
